// Horizon admin sidebar: fixed panel on desktop (xl+), drawer on mobile.
import { Box, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex, useColorModeValue } from "@chakra-ui/react";
import SidebarBrand from "./SidebarBrand";
import SidebarLinks from "./SidebarLinks";

const SCROLL_SX = {
  overflowY: "auto",
  overflowX: "hidden",
  "::-webkit-scrollbar": { width: "6px" },
  "::-webkit-scrollbar-thumb": { background: "rgba(163,174,208,0.4)", borderRadius: "10px" }
};

/**
 * Inner scrollable sidebar content (brand + navigation links).
 * @param {Object} props - routes, userRight, badges, onNavigate
 * @returns {React.ReactElement}
 */
function SidebarContent({ routes, userRight, badges, onNavigate }) {
  return (
    <Flex direction="column" h="100%" py="20px">
      <SidebarBrand />
      <Box flex="1" px="16px" mt="8px" sx={SCROLL_SX}>
        <SidebarLinks routes={routes} userRight={userRight} badges={badges} onNavigate={onNavigate} />
      </Box>
    </Flex>
  );
}

/**
 * Responsive sidebar: permanent fixed panel (xl+) and mobile drawer.
 * @param {Object} props - routes, userRight, badges, isOpen, onClose
 * @returns {React.ReactElement}
 */
export default function Sidebar({ routes, userRight, badges, isOpen, onClose }) {
  const sidebarBg = useColorModeValue("rgba(255, 255, 255, 0.7)", "rgba(255, 255, 255, 0.04)");
  const borderColor = useColorModeValue("rgba(255, 255, 255, 0.5)", "rgba(255, 255, 255, 0.08)");
  const shadow = useColorModeValue("14px 17px 40px 4px rgba(112, 144, 176, 0.08)", "unset");
  const blur = "blur(20px) saturate(140%)";
  const content = (
    <SidebarContent routes={routes} userRight={userRight} badges={badges} onNavigate={onClose} />
  );
  return (
    <>
      <Box display={{ base: "none", xl: "block" }} position="fixed" top="0" left="0"
        w="300px" h="100vh" bg={sidebarBg} backdropFilter={blur} WebkitBackdropFilter={blur}
        borderRight="1px solid" borderColor={borderColor} boxShadow={shadow} zIndex="20">
        {content}
      </Box>
      <Drawer isOpen={isOpen} onClose={onClose} placement="left">
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBg} backdropFilter={blur}
          WebkitBackdropFilter={blur}>
          <DrawerBody p="0">{content}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
